// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import fileShield02Icon from "@/assets/icons/file-shield-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FileShield02IconProps = Omit<IconProps, "name">;

export function FileShield02Icon(props: FileShield02IconProps): React.ReactNode {
  return <Icon name={fileShield02Icon} {...props} />;
}
